var my_account_controller = {
    selector: '.syn-wc-my-account',
    validate: true,
    logged_in: null,
    endpoints: {
        'addresses': '/wp-json/portacool/v1/wc_addresses',
        'validate_address': '/wp-json/portacool/v1/wc_register_address_validation'
    },
    init: function(){
        var $this = jQuery(this.selector);
        if($this.length){
            var logged_in = $this.hasClass('logged-in');
            this.logged_in = logged_in;
        }

        var $redirect_to = jQuery('input[name="redirect_to"]');
        if($redirect_to.length && !$redirect_to.val() && typeof document.referrer !== 'undefined' && document.referrer != ''){
            $redirect_to.val(document.referrer);
        }

        if(!this.logged_in){
            jQuery('.cta.show-register-form').on('click', function(){
                my_account_controller.show_register_form();
            });

            jQuery('button.show-login').on('click', function(){
                my_account_controller.show_login_form();
            });

            var $form = jQuery(my_account_controller.selector + ' .register-second-step > form');

            if($form.length){
                my_account_controller.register_submit_event($form);
            }

        }else{
            var check = this.get_address_template();
            if(check){
                this.address_form = check;
                this.bind_address_events();
            }else{
                this.check_for_password_form();
            }
            jQuery('#account-nav-select').on('change', function(){
                var new_url = jQuery(this).val();
                window.location.href = new_url;
            });
        }

        this.set_up_password_tests();
    },
    register_submit_event: function($form){
        $form.on('submit', function(e){
            if(my_account_controller.validate){
                e.preventDefault();
                e.stopImmediatePropagation();
                my_account_controller.register_form_show_loading($form);
                $form.find('.error').removeClass('error');
                $form.find('.error-message').remove();
                var data = $form.serializeArray();
                data = my_account_controller.restructure_form_data(data);
                $.post(my_account_controller.endpoints.validate_address, data).always(function(response){
                    my_account_controller.register_form_remove_loading($form);
                }).done(function(response){
                    if(response.success){
                        var $form = jQuery(my_account_controller.selector + ' .register-second-step > form');
                        my_account_controller.validate = false;
                        $form.find('button[type="submit"]').trigger('click');
                        
                        //alert('Form validated successfully.');
                    }else{
                        //alert('An error occurred while validating the address.');
                        var $form = jQuery(my_account_controller.selector + ' .register-second-step > form');
                        my_account_controller.register_form_show_errors($form, response.errors);
                    }
                });
            }
        });
    },
    register_form_show_loading: function($form){
        $form.addClass('loading');
        //showLoadingBlock($form);
    },
    register_form_remove_loading: function($form){
        $form.removeClass('loading');
        //hideLoadingBlock($form);
    },
    register_form_show_errors: function($form, errors){
        for(var key in errors){
            if(
                key.search('address_') != -1
            ){
                var new_key = key.replace('address_', 'billing_');
                var $input = $form.find('input[name="'+new_key+'"],select[name="'+new_key+'"]');
                if($input.length == 0){
                    var new_key = key.replace('address_', '');
                    var $input = $form.find('input[name="'+new_key+'"],select[name="'+new_key+'"]');
                }
                if($input.length == 0){
                    var new_key = 'billing_'+key;
                    var $input = $form.find('input[name="'+new_key+'"],select[name="'+new_key+'"]');
                }
                var $container = $input.closest('.form-row');
                $container.addClass('error');
                $container.append('<div class="error-message">'+errors[key]+'</div>');
            }
        }

        if($form.find('.error-message').length){
            var offset = $form.find('.error-message').first().offset().top - 300;
            jQuery('html, body').animate({scrollTop: offset}, 500);
        }
    },
    check_for_password_form: function(){
        var $form = jQuery('.edit-password-form');
        if($form.length){
            $form.find('.cta.save').on('click', function(){
                my_account_controller.save_password($form);
            });
        }
    },
    rate_password: function(password){
        var min_length = 12;
        var special_chars_pattern = /[!@#\$%\^\&*]/;
        var numbers_pattern = /[0-9]/;
        var upper_case_pattern = /[A-Z]/;
        var lower_case_pattern = /[a-z]/;
        var errors = [];
        if(password.length < min_length){
            errors.push({
                'message': 'Password must be at least 12 characters long.'
            });
        }

        if(!special_chars_pattern.test(password)){
            errors.push({
                'message': 'Password must contain at least one of the following: !@#$%^\&*.'
            });
        }
        if(!numbers_pattern.test(password)){
            errors.push({
                'message': 'Password must contain at least one number.'
            });
        }
        if(!upper_case_pattern.test(password)){
            errors.push({
                'message': 'Password must contain at least one upper case letter.'
            });
        }
        if(!lower_case_pattern.test(password)){
            errors.push({
                'message': 'Password must contain at least one lower case letter.'
            });
        }

        if(errors.length){
            return {
                'pass': false,
                'errors': errors
            };
        }else{
            return {
                'pass': true
            };
        }
    },
    compare_passwords: function(password, confirm_password){
        if(password == confirm_password){
            return true;
        }

        return false;
    },
    set_up_password_tests: function(){
        var password_selector = 'input[name="new_password"],input[name="password_1"],input#reg_password[name="password"]';
        var confirm_password_selector = 'input[name="confirm_password"],input[name="password_2"]';

        var $password = jQuery(password_selector);
        var $confirm_password = jQuery(confirm_password_selector);

        if(!$password.length || !$confirm_password.length){
            return;
        }

        $password.on('keyup change', function(){
            var $this = jQuery(this);
            //console.log('Fireing on', $this);
            $this.removeClass('error');
            $this.removeClass('success');
            var $parent = $this.closest('.form-row');
            $parent.find('.password-error').remove();
            $parent.removeClass('error');
            $parent.removeClass('success');
            var password = $this.val();
            var rating = my_account_controller.rate_password(password);
            if(rating.pass == false){
                //console.log('Password Errors', rating.errors);
                $this.addClass('error');
                var message = '';
                $parent.addClass('error');
                rating.errors.forEach(function(error){
                    message += '<div class="password-error">'+error.message+'</div>';
                });
                $parent.append(message);
            }else{
                //console.log('success');
                $this.addClass('success');
                $parent.addClass('success');
            }
        });

        $confirm_password.on('keyup change', function(){
            var $this = jQuery(this);
            $this.removeClass('error');
            $this.removeClass('success');
            var $parent = $this.closest('.form-row');
            $parent.find('.password-error').remove();
            $parent.removeClass('error');
            $parent.removeClass('success');
            var password = $password.val();
            var confirm_password = $this.val();
            var match = my_account_controller.compare_passwords(password, confirm_password);
            if(match){
                $this.addClass('success');
                $parent.addClass('success');
            }else if(confirm_password == ''){
                //Do nothing, but remove the error and success classes.
            }else{
                $this.addClass('error');
                $parent.addClass('error');
                $parent.append('<div class="password-error">Passwords do not match.</div>');
            }
        });
    },
    save_password: function($form){
        var data = $form.serializeArray();
        data = my_account_controller.restructure_form_data(data);

        if(data.current_password == ''){
            alert('Current password is required.');
            return;
        }

        if(data.new_password == ''){
            alert('New password is required.');
            return;
        }

        if(data.confirm_password == ''){
            alert('Confirm password is required.');
            return;
        }

        //Replace the below with validation messages on the form
        if(data.new_password != data.confirm_password){
            alert('Passwords do not match.');
            return;
        }

        if(data.new_password.length < 12){
            alert('Password must be at least 12 characters long.');
            return;
        }

        if(data.current_password == data.new_password){
            alert('New password must be different from the current password.');
            return;
        }

        var endpoint = '/wp-json/syn_wpb/v1/update_password';

        //var $button = $form.find('.cta.save');
        //$button.addClass('loading');

        $.post(endpoint, data).always(function(response){
            $button.removeClass('loading');
            if(response.success){
               // dialog_controller.close_closest_dialog($button);w
               dialog_controller.display_dialog({title: 'Password Changed', content: 'Your password has been changed successfully.'});
               $form.find('input').each(function(){
                    jQuery(this).val('');
               });
            }else{
                alert('An error occurred while saving the password.');
                //my_account_controller.display_password_form_errors($form, response.errors);
            }
        }).fail(function(){
            alert('An error occurred while saving the password.');
        });
    },
    show_register_form: function(){
        jQuery(my_account_controller.selector + ' .login-form, '+ my_account_controller.selector +' .register-first-step, .divider').addClass('hidden');
        jQuery(my_account_controller.selector + ' .register-second-step').removeClass('hidden');
        //Scroll to the top of the form.
        var $form = jQuery(my_account_controller.selector + ' .register-second-step');
        var offset = $form.offset().top;
        jQuery('html, body').animate({scrollTop: offset}, 500);
    },
    show_login_form: function(){
        jQuery(my_account_controller.selector + ' .register-second-step').addClass('hidden');
        jQuery(my_account_controller.selector + ' .login-form, '+ my_account_controller.selector +' .register-first-step, .divider').removeClass('hidden');
    },

    address_form_selector: 'template#address-form',
    address_form: false,
    get_address_template: function(){
        var $template = jQuery(my_account_controller.address_form_selector);
        if($template.length){
            return $template.html();
        }else{
            return false;
        }
    },
    bind_address_events: function(){
        jQuery('.add-address').on('click', function(){
            my_account_controller.add_address_form();
        });
        jQuery('.address-row .address .edit').on('click', function(){
            my_account_controller.edit_address_form(jQuery(this));
        });
    },
    bind_address_form_controls($dialog){
        $form = $dialog.find('form');

        $form.find('.cta.cancel').on('click', function(){
            dialog_controller.close_closest_dialog(this);
        });

        $form.find('.cta.save').on('click', function(){
            dialog_controller.loading_closest_dialog(this);
            my_account_controller.save_address($form);
        });

        $form.find('.cta.delete').on('click', function(){
            my_account_controller.delete_address($form);
        });
    },
    delete_address: function($form){
        var data = $form.serializeArray();
        data = my_account_controller.restructure_form_data(data);

        data.delete = true;

        var endpoint = my_account_controller.endpoints.addresses;

        var $dialog = $form.closest('.dialog');

        var $button = $form.find('.cta.delete');
        $button.addClass('loading');

        $.post(endpoint, data).always(function(response){
            //$button.removeClass('loading');
            var $button = $form.find('button');
            if($button.length){
                var button = $button[0];
                dialog_controller.loaded_closest_dialog(button);
            }
            /*if(response.success){
                dialog_controller.close_closest_dialog($button);
                my_account_controller.reload_addresses(response);
            }else{
                //alert('An error occurred while saving the address.');
            }*/
        }).done(function(response){
            $button.removeClass('loading');
            if(response.success){
                dialog_controller.close_closest_dialog($button);
                $dialog.remove();
                my_account_controller.reload_addresses(response);
                toast_controller.display_toast('Address deleted successfully.', 'success');
            }else{
                //alert('An error occurred while saving the address.');
                my_account_controller.display_address_form_errors($form, response.errors);
            }
        }).fail(function(){
            //alert('An error occurred while saving the address.');
        });
    },
    save_address: function($form){
        var errors = my_account_controller.frontend_validate_address_form($form);
        if(Object.keys(errors).length){
            var $button = $form.find('button');
            my_account_controller.display_address_form_errors($form, errors);
            if($button.length){
                var button = $button[0];
                dialog_controller.loaded_closest_dialog(button);
            }
            return;
        }

        var data = $form.serializeArray();
        data = my_account_controller.restructure_form_data(data);

        var endpoint = my_account_controller.endpoints.addresses;

        var $dialog = $form.closest('.dialog');

        var $button = $form.find('.cta.save');
        $button.addClass('loading');

        $.post(endpoint, data).always(function(response){
            //$button.removeClass('loading');
            var $button = $form.find('button');
            if($button.length){
                var button = $button[0];
                dialog_controller.loaded_closest_dialog(button);
            }
            /*if(response.success){
                dialog_controller.close_closest_dialog($button);
                my_account_controller.reload_addresses(response);
            }else{
                //alert('An error occurred while saving the address.');
            }*/
        }).done(function(response){
            $button.removeClass('loading');
            if(response.success){
                dialog_controller.close_closest_dialog($button);
                $dialog.remove();
                my_account_controller.reload_addresses(response);
                toast_controller.display_toast('Address saved successfully.', 'success');
            }else{
                //alert('An error occurred while saving the address.');
                my_account_controller.display_address_form_errors($form, response.errors);
            }
        }).fail(function(){
            //alert('An error occurred while saving the address.');
        });
    },
    reload_addresses: function(response){
        var address_html = response.address_html;
        jQuery('.address-row').html(address_html);
        my_account_controller.bind_address_events();
    },
    restructure_form_data: function(form_data){
        var final_data = {};
        form_data.forEach(function(item){
            final_data[item.name] = item.value;
        });
        return final_data;
    },
    frontend_validate_address_form: function($form){
        var errors = {};
        $form.find('.error').removeClass('error');
        $form.find('.error-message').remove();
        $form.find('input,select,textarea').each(function(){
            $this = jQuery(this);
            if($this.attr('required') && !$this.val()){
                errors[$this.attr('name')] = 'required';
            }
        });

        var type = $form.find('input[name="type"]').val();
        if(type == 'S'){
            var po_pattern = /p\.{0,1}o\.{0,1}\s?(box)?\s?[0-9]*/i;
            var address_1 = $form.find('input[name="address_1"]').val();
            var address_2 = $form.find('input[name="address_2"]').val();
            if(address_1.search(po_pattern) != -1 || address_2.search(po_pattern) != -1){
                errors['address_1'] = 'po_box';
            }
        }

        return errors;
    },
    display_address_form_errors: function($form, errors){
        $form.find('.error').removeClass('error');
        jQuery.each(errors, function(index, value){

            var name = index;
            var message = value;

            var $input = $form.find('[name="'+name+'"]');
            $container = $input.closest('.form-group');
            $container.addClass('error');
            var $label = $container.closest('.form-group').find('label');
            var label = $label.text();
            $container.find('.error-message').remove();

            if(message == 'required'){
                label = label.replace(' *', '');
                message = label+' is required.';
            }else if(message == 'po_box'){
                label = label.replace(' *', '');
                message = label+' cannot be a PO Box. Physical addresses are required for shipping our products.';
            }

            $container.append('<div class="error-message">'+message+'</div>');
        });
    },
    add_address_form: function(){

        $form = jQuery(my_account_controller.address_form);

        $form.find('.cta.delete').remove();
        $form.find('.sub-row.justify-space-between.horizontal').removeClass('justify-space-between').addClass('justify-end');

        $dialog = dialog_controller.display_dialog({
            'title': 'Add Shipping Address',
            'content': $form.prop('outerHTML'),
        });

        my_account_controller.bind_address_form_controls($dialog);
        
    },
    edit_address_form: function($this){
        
        var data = $this.closest('.address').data('details');
        var $form = jQuery(my_account_controller.address_form);
        //console.log(data);

        var billing = data['type'] == 'B' ? true : false;

        $.each(data, function(key, value){
            //console.log(key, value);
            if(key != 'default'){
                //$form.find('input[name="'+key+'"],select[name="'+key+'"],textarea[name="'+key+'"]').val(value);

                var translations = {
                    id: 'address_id',
                    phone: 'address_phone',
                    email: 'address_email',
                    city: 'address_city',
                    state: 'address_state',
                    postal_code: 'address_postcode',
                    notes: 'address_notes'
                };

                if(typeof translations[key] !== 'undefined'){
                    key = translations[key];
                }

                $input = $form.find('input[name="'+key+'"]');
                if($input.length){
                    $input.attr('value', value);
                }else{
                    $input = $form.find('select[name="'+key+'"]');
                    if($input.length){
                        $input.find('option[value="'+value+'"]').attr('selected', true);
                    }else{
                        $input = $form.find('textarea[name="'+key+'"]');
                        if($input.length){
                            $input.html(value);
                        }
                    }
                }
            }else{
                if(data['type'] == 'S'){
                    if(value && value == '1'){
                        console.log('Shipping address default value: ' + value);
                        $form.find('input[name="address_default"]').attr('checked', value);
                    }
                }else{
                    //Only one billing address is allowed, remove the default control.
                    $form.find('input[name="address_default"]').closest('.form-group.default').remove();
                    //Remove delete button
                    $form.find('.cta.delete').remove();
                    $form.find('.sub-row.justify-space-between.horizontal').removeClass('justify-space-between').addClass('justify-end');
                }
            }
        });

        title = 'Edit Shipping Address';
        if(billing){
            title = 'Edit Billing Address';
        }

        $dialog = dialog_controller.display_dialog({
            'title': title,
            'content': $form[0].outerHTML,
        });

        my_account_controller.bind_address_form_controls($dialog);
    }
};

window.my_account_controller = my_account_controller;
jQuery(document).ready(function(){
    my_account_controller.init();
    toast_controller.toast_target = '.my-account-toast-container';
});